<div
  class="cookie-alert"
  *ngIf="isCookieAlertEnabled"
  [class.hidden]="cookieAlertDisplayStatus === 'invisible'"
>
  <app-cookies-agreement
    [alertText]="VO.cookie_alert_text.description"
    [alertButtonText]="VO.cookie_alert_button_text.title"
    (disableCookie)="disableCookieAlert()"
  ></app-cookies-agreement>
</div>

<mob-header-landing
  [VO]="VoHeader"
  (clickEvent)="validate()"
></mob-header-landing>
<div class="mob-banner">
  <div
    class="mob-banner-background"
    [ngStyle]="{
      'background-image': isMobileOrDesk()
        ? 'url(' +
          normalizeImage(VO.topBanner_Mobile, isMock, 'top-banner-mobile') +
          ')'
        : 'url(' +
          normalizeImage(VO.topBanner_Desktop, isMock, 'top-banner-desktop') +
          ')'
    }"
  ></div>
  <div class="container">
    <div class="row">
      <div class="col-12 d-flex jc-flex-end">
        <div>
          <div class="mob-form">
            <div class="mob-title-1 mb-16 mb-lg-24">{{ VO?.title }}</div>
            <div class="mob-text-1 mb-16 mb-40">{{ VO?.subtitle }}</div>

            <form [formGroup]="form" *ngIf="form" class="form">
              <div class="row">
                <div class="col-md-7 col-sm-12">
                  <div class="margin-bottom-cel">
                    <dss-form-field
                      [isError]="formSubmitted && cpf.invalid"
                      autocomplete="off"
                    >
                      <input
                        id="inputCPF"
                        #cpfElementTop
                        type="text"
                        formControlName="cpf"
                        trackingFill
                        [eventLabel]="'input:cpf'"
                        dssMask="CPF"
                        autocomplete="off"
                        inputmode="numeric"
                      />
                      <label id="labelCPF" dssLabel>{{
                        VO?.documentCPF?.label
                      }}</label>
                      <span *ngIf="cpf?.errors?.required" dssError>
                        {{ VO?.documentCPF?.validator_required }}</span
                      >
                      <span *ngIf="cpf?.errors?.invalidCPF" dssError>{{
                        VO?.documentCPF?.validator_invalidFormat
                      }}</span>
                    </dss-form-field>
                  </div>
                </div>
                <div class="col-md-5 col-sm-12">
                  <div class="ta-righ">
                    <mob-button
                      *ngIf="VO?.continueButton?.label"
                      [type]="'landing-page'"
                      [styleClass]="
                        'mob-btn mob-btn-primary mob-btn-3 min-w-200 mob-btn-conta'
                      "
                      (actionClick)="send($event)"
                      [text]="VO?.continueButton?.label"
                      [eventLabel]="'botao:quero-abrir-conta-2'"
                      [action]="'next-top'"
                    >
                    </mob-button>
                  </div>
                  <!-- <p class="mob-disclaimer view-mobile">
                    *Sujeito à análise de crédito. *Produtos podem ser
                    contratados de forma independente.
                  </p> -->
                </div>
              </div>
            </form>
          </div>
          <!-- <p class="mob-disclaimer">
            *Sujeito à análise de crédito. *Produtos podem ser contratados de
            forma independente.
          </p> -->
        </div>
      </div>
    </div>
  </div>
</div>
<mob-offer [VO]="VO"></mob-offer>
<mob-benefits-package [VO]="VO"></mob-benefits-package>
<mob-offer-card
  [cpf]="cpfOfferCard"
  [formSubmitted]="offerCardFormSubmitted"
  [form]="formOfferCard"
  [VO]="VO"
  [isMock]="isMock"
  (startCmcFlow)="send($event)"
  (sendTag)="sendTag($event)"
></mob-offer-card>
<mob-step-by-step [VO]="VO" [isMock]="isMock"></mob-step-by-step>

<div class="mob-boxes">
  <div class="mob-row">
    <div
      class="mob-box-1"
      [ngStyle]="{
        'background-image':
          'url(' +
          normalizeImage(VO.boxes_imagem_1, isMock, 'Santandermobile') +
          ')'
      }"
    ></div>
    <div class="mob-bg-soft-white">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="mob-box-2">
              <div class="mob-title-3 mb-16 mb-lg-24">
                {{ VO?.boxes_1_title }}
              </div>
              <div
                class="mob-text-5 mb-8"
                [innerHTML]="VO?.boxes_1_description"
              ></div>
              <div class="mob-text-5">{{ VO?.boxes_1_subtitle }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mob-row">
    <div
      class="mob-box-4"
      [ngStyle]="{
        'background-image':
          'url(' +
          normalizeImage(
            VO.boxes_imagem_2,
            isMock,
            'img_peca-cartao_sx_more_conta'
          ) +
          ')'
      }"
    ></div>

    <div class="mob-bg-boston">
      <div class="container">
        <div class="row">
          <div class="col-0 col-md-6"></div>
          <div class="col-12 col-md-6">
            <div class="mob-box-3">
              <div
                class="mob-title-1 mob-white mb-24 mb-lg-40"
                [innerHtml]="VO?.boxes_2_title"
              ></div>

              <form
                [formGroup]="formFooter"
                *ngIf="formFooter"
                class="mob-input mob-over-red mb-24"
                autocomplete="off"
              >
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 margin-bottom">
                    <dss-form-field
                      [isError]="formFooterSubmitted && cpfFooter.invalid"
                    >
                      <input
                        id="cpf"
                        class="mob-btn-4"
                        #cpfElementFooter
                        type="text"
                        formControlName="cpf"
                        trackingFill
                        [eventLabel]="'input:cpf'"
                        dssMask="CPF"
                        autocomplete="off"
                        inputmode="numeric"
                      />
                      <label id="label" dssLabel>{{
                        VO?.documentCPF?.label
                      }}</label>
                      <span
                        id="error"
                        *ngIf="cpfFooter?.errors?.required"
                        dssError
                      >
                        {{ VO?.documentCPF?.validator_required }}</span
                      >
                      <span
                        id="error"
                        *ngIf="cpfFooter?.errors?.invalidCPF"
                        dssError
                        >{{ VO?.documentCPF?.validator_invalidFormat }}</span
                      >
                    </dss-form-field>
                  </div>
                  <br />
                  <br />
                  <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
                    <mob-button
                      *ngIf="VO?.continueButton?.label"
                      [type]="'landing-page'"
                      [styleClass]="
                        'mob-btn-2 mob-btn-secondary mob-btn-5 mob-btn-conta'
                      "
                      (actionClick)="send($event)"
                      [text]="VO?.continueButton?.label"
                      [eventLabel]="'botao:quero-abrir-conta-2'"
                      [action]="'next-footer'"
                    >
                    </mob-button>
                  </div>
                </div>
              </form>
            </div>
            <div class="mob-text-2 mob-white mb-24 mb-lg-16">
              {{ VO?.boxes_2_subtitle }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<mob-legal [VO]="VoFooter"></mob-legal>
<mob-floating-button
  [VO]="VO"
  (getCpfOnClick)="reciveCpf($event)"
  *ngIf="showFloatingButton"
></mob-floating-button>
